const defaultState = {
  routes: null,
  error: null,
  fetching: false,
  fetched: false
};

const getRoutesReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'CLEAR_ROUTES': {
      return {
        ...state, error: null, fetching: true, routes: null,
      };
    }
    case 'ROUTES_FETCH_PENDING': {
      return {
        ...state, error: null, fetching: true, routes: null,
      };
    }
    case 'ROUTES_FETCH_FULFILLED': {
      return {
        ...state, fetching: false, fetched: true, error: null, routes: action.payload.routes
      };
    }
    case 'ROUTES_FETCH_REJECTED': {
      return {
        ...state, fetching: true, fetched: false, error: action.payload, routes: null
      };
    }
    default: {
      break;
    }
  }

  return state;
};

export default getRoutesReducer;


// WEBPACK FOOTER //
// ./src/reducers/getRoutes.js